export enum UserRole {
  SuperAdmin = 'superadmin',
  Admin = 'admin',
  EndUser = 'enduser',
}

export enum RolePolicy {
  SuperAdmin = 'superadmin',
  Admin = 'admin',
  EndUser = 'enduser',
  AdminProfilePage = 'read:adminProfile',
  AdminUsersPage = 'read:users',
  AdminAccountsPage = 'read:accounts',
  AdminTransactionsPage = 'read:transactions',
  AdminCouponsPage = 'read:coupons',
  AdminPayoutsPage = 'read:payouts',
  AdminFinancePage = 'read:finance',
  AdminKYCPage = 'read:kyc',
  AdminUserNotesPage = 'read:userNotes',
  AdminAffiliatesPage = 'read:affiliates',
  AdminOrganizationPage = 'read:organization',
  AdminLogPage = 'read:audits',
  AdminUpdatePayoutBatch = 'update:payoutBatches',
  AdminPurchaseOrdersPage = 'read:purchaseOrders',
  AdminSavedCardsPage = 'read:savedCards',
  AdminNmiSubscriptionsPage = 'read:nmiSubscriptions',
  AdminUserSubscriptionsPage = 'read:userSubscriptions',
  AdminOfacPepSanctionsPage = 'read:ofacPepSanctions',
  AdminImpactGroupsPage = 'read:impactGroups',
  KycSettingsPage = 'read:kycPriorityConfig',

  // Action Specific Policies
  CouponCreate = 'create:coupons',
  CouponUpdate = 'update:coupons',
  CouponDelete = 'delete:coupons',
  AdminKYCUpdate = 'update:verificationStatus',
  ResetCreditCreate = 'create:resetCredits',
  ResetCreditUpdate = 'update:resetCredits',
  ResetCreditDelete = 'delete:resetCredits',
  SubscriptionUpdate = 'update:subscriptions',
  RefundCreate = 'create:refunds',
  ReadTaxForms = 'read:taxForms',
  UpdateTaxForms = 'update:taxForms',
  CreateUser = 'create:users',
  GDPRUser = 'gdpr:users',
  ReadBankInformation = 'read:bankingInfo',
  XFAActivationCreditCreate = 'create:xfaActivationCredits',
  XFAActivationCreditUpdate = 'update:xfaActivationCredits',
  XFAActivationCreditDelete = 'delete:xfaActivationCredits',
  ReadUserType = 'read:userType',
  AdminImpactGroupsCreate = 'create:impactGroups',
  ReadTraderRiskIndicators = 'read:traderRiskIndicators',
}

export const AllPolicies = [RolePolicy.SuperAdmin, RolePolicy.Admin, RolePolicy.EndUser];

// Map from user role to the policies that role has
export const rolePolicyMap: { [key: string]: RolePolicy[] } = {
  [UserRole.SuperAdmin]: [RolePolicy.SuperAdmin],
  [UserRole.Admin]: [RolePolicy.Admin],
  [UserRole.EndUser]: [RolePolicy.EndUser],
};

//--------------------------------------------------------//
//      ___                  ___       ___     _          //
//     / _ \___ ____ ____   / _ \___  / (_)___(_)__ ___   //
//    / ___/ _ `/ _ `/ -_) / ___/ _ \/ / / __/ / -_|_-<   //
//   /_/   \_,_/\_, /\__/ /_/   \___/_/_/\__/_/\__/___/   //
//             /___/                                      //
//--------------------------------------------------------//

export const PagePolicies = {
  // Pages //
  DashboardPage: AllPolicies,
  AdminProfilePage: [RolePolicy.SuperAdmin, RolePolicy.AdminProfilePage],
  AdminUsersPage: [RolePolicy.SuperAdmin, RolePolicy.AdminUsersPage],
  AdminCouponsPage: [RolePolicy.SuperAdmin, RolePolicy.AdminCouponsPage],
  AdminPayoutsPage: [RolePolicy.SuperAdmin, RolePolicy.AdminPayoutsPage],
  AdminPayoutBatchesPage: [
    RolePolicy.SuperAdmin,
    RolePolicy.AdminPayoutsPage,
    RolePolicy.AdminUpdatePayoutBatch,
  ],
  AdminKYCPage: [RolePolicy.SuperAdmin, RolePolicy.AdminKYCPage],
  AdminOfacPepSanctionsPage: [RolePolicy.SuperAdmin, RolePolicy.AdminOfacPepSanctionsPage],
  AdminFinancePage: [RolePolicy.SuperAdmin, RolePolicy.AdminFinancePage],
  AdminUserNotesPage: [RolePolicy.SuperAdmin, RolePolicy.AdminUserNotesPage],
  AdminAffiliatesPage: [RolePolicy.SuperAdmin, RolePolicy.AdminAffiliatesPage],
  AdminOrganizationPage: [RolePolicy.SuperAdmin, RolePolicy.AdminOrganizationPage],
  AdminLogPage: [RolePolicy.SuperAdmin, RolePolicy.AdminLogPage],
  AdminAccountsPage: [RolePolicy.SuperAdmin, RolePolicy.AdminAccountsPage],
  AdminTransactionsPage: [RolePolicy.SuperAdmin, RolePolicy.AdminTransactionsPage],
  AdminPaymentMethodsPage: [RolePolicy.SuperAdmin, RolePolicy.ReadBankInformation],
  EndUserProfilePage: [RolePolicy.EndUser],
  EndUserAccountsPage: [RolePolicy.EndUser],
  EndUserPayoutsPage: [RolePolicy.EndUser],
  EndUserCertificatesPage: [RolePolicy.EndUser],
  AdminImpactGroupsPage: [RolePolicy.SuperAdmin, RolePolicy.AdminImpactGroupsPage],
  KycFraudReviewSettingsPage: [RolePolicy.SuperAdmin, RolePolicy.KycSettingsPage],
};

//--------------------------------------------------------------------------//
//       ___        __  _                ____        ___      _             //
//      /   | _____/ /_(_)___  ____     / __ \____  / (_)____(_)__  _____   //
//     / /| |/ ___/ __/ / __ \/ __ \   / /_/ / __ \/ / / ___/ / _ \/ ___/   //
//    / ___ / /__/ /_/ / /_/ / / / /  / ____/ /_/ / / / /__/ /  __(__  )    //
//   /_/  |_\___/\__/_/\____/_/ /_/  /_/    \____/_/_/\___/_/\___/____/     //
//                                                                          //
//--------------------------------------------------------------------------//

export const ActionPolicies = {
  // users
  DeleteUser: [RolePolicy.SuperAdmin],
  ViewUser: [RolePolicy.SuperAdmin, RolePolicy.Admin],
  CreateImpactGroup: [RolePolicy.SuperAdmin, RolePolicy.AdminImpactGroupsCreate],
};
